import {Connection, Meter} from '@flowmaps-com/flowmaps-typescriptmodels';
import {isCalculatedResidual, isMeterVisible, isPercentageAllocated} from '../../meters/submeter-role.utils';

export function isManualUploadProvider(code?: string): boolean {
  return code === 'flowmaps' || code === '8f4d2bfb-169d-4983-b042-b235d3a36d8f';
}

/** Uploaded source meters survive source changes and deleted periods. Do not require an active meter. */
export function isUploadSourceMeter(meter?: Meter): boolean {
  return !!meter && isMeterVisible(meter) && !isCalculatedResidual(meter) && !isPercentageAllocated(meter)
    && isManualUploadProvider(meter.info?.surveyor?.code);
}

export function hasUploadAccess(connection?: Connection): boolean {
  return !!connection?.connectionId && (isManualUploadProvider(connection.info?.surveyor?.code)
    || (connection.meters || []).some(isUploadSourceMeter));
}
